import React, { useContext, useEffect, useState } from "react";
import AdminContext from "../../StateContext/Application";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Link, useNavigate, useLocation } from "react-router-dom";
import GooglePagination from "../../styles/GooglePagination";
import { filterStyle,filterWrapperStyle } from "../../styles/filterStyles";
function GRSanctionWorks() {
  const { t } = useLanguage();
  const nav = useNavigate();
  const navigate = useNavigate();
  const context = useContext(AdminContext);
  const { GetAllProposalList, GetBudgetHeadInfo, Usermenu } = context;
  const [loading, setloading] = useState(false);
  const [proposallist, setProposalList] = useState([]);
  const budgetEstimation = proposallist;
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [openDistrict, setOpenDistrict] = useState(false);
  const [SelectedDistrict, setSelectedDistrict] = useState([]);
  const [AllDistrict, setAllDistrict] = useState([]);
  const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] =
    useState("");
  const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredBills, setFilteredBills] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [RoleID, setRoleID] = useState(null);
  const [typeofData, settypeofData] = useState(null);
  const [UserRole, setUserRole] = useState("State");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const filters = {
    SelectedDistrict,
    SelectedTalukasofDistrict,
    selectedYear,
    searchTerm,
    selectedStatus,
    typeofData,
    currentPage,
  };
  const location = useLocation();
  // Pagination calculations
  const totalPages = Math.ceil(filteredBills.length / billsPerPage);
  const indexOfLast = currentPage * billsPerPage;
  const indexOfFirst = indexOfLast - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirst, indexOfLast);
  const [exportingPDF, setExportingPDF] = useState(false);

  const displayedGRS = exportingPDF ? filteredBills : currentBills;
  const FetchGramPanachayatInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "AllDistrict");
      setAllDistrict(res);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    FetchGramPanachayatInfo();
  }, []);

// const allDistricts = [
//   ...new Set(
//     AllDistrict
//       ?.map((d) =>
//         d?.District_Marathi?.split("-")[0]?.trim()
//       )
//       .filter(Boolean)
//   ),
// ];
//   const isAllSelected = SelectedDistrict.length === allDistricts.length;

  const allDistricts = [
  ...new Set(
    AllDistrict?.map((d) =>
      d?.District_Marathi?.split("-")[0]?.trim()
    ).filter(Boolean)
  ),
].sort((a, b) => a.localeCompare(b, "mr"));
const isAllSelected =
  allDistricts.length > 0 &&
  SelectedDistrict.length === allDistricts.length;

  const toggleAllDistricts = () => {
    setSelectedDistrict(isAllSelected ? [] : allDistricts);
  };
  const toggleDistrict = (district) => {
    setSelectedDistrict((prev) =>
      prev.includes(district)
        ? prev.filter((d) => d !== district)
        : [...prev, district],
    );
  };
 useEffect(() => {
  if (SelectedDistrict && SelectedDistrict.length > 0) {
    const res = AllDistrict.filter((item) => {
      const itemDistrict = item?.District_Marathi || "";

      return SelectedDistrict.some(
        (district) =>
          itemDistrict === district ||
          itemDistrict.startsWith(`${district}-`)
      );
    });

    setTalukasofDistrict(res);
  } else {
    setSelectedTalukasofDistrict("");
    setTalukasofDistrict([]);
    // removed setSelectedDistrict("") — SelectedDistrict is already
    
  }
}, [SelectedDistrict, AllDistrict]);

  useEffect(() => {
    setSelectedTalukasofDistrict("");
  }, [SelectedDistrict]);

  // 🔹 Toggle single district
  // useEffect(() => {
  //   let filtered = [...budgetEstimation];

  //   filtered = filtered.filter(item => {
  //     // 🔹 District filter (MULTI)
  //     if (
  //       SelectedDistrict &&
  //       SelectedDistrict.length > 0 &&
  //       !SelectedDistrict.includes(item.Districts)
  //     ) {
  //       return false;
  //     }

  //     // 🔹 Taluka filter (single – unchanged)
  //     if (
  //       SelectedTalukasofDistrict &&
  //       item.Talukas !== SelectedTalukasofDistrict
  //     ) {
  //       return false;
  //     }

  //        // 🔹 Year filter (single)
  //     if (
  //       selectedYear &&
  //       item.Proposal_year !== selectedYear
  //     ) {
  //       return false;
  //     }
  //     return true;
  //   });

  //   // 🔹 Search filter (last)
  //   if (searchTerm.trim()) {
  //     const lower = searchTerm.toLowerCase();
  //     filtered = filtered.filter(item =>
  //       Object.values(item).some(val =>
  //         String(val ?? "")
  //           .toLowerCase()
  //           .includes(lower)
  //       )
  //     );
  //   }

  //   setFilteredBills(filtered);
  //   setCurrentPage(1);

  // }, [
  //   budgetEstimation,
  //   SelectedDistrict,          // array
  //   SelectedTalukasofDistrict,
  //     selectedYear,
  //   searchTerm ,
  //   typeofData
  // ]);
  useEffect(() => {
    let filtered = [...budgetEstimation];

    // 🔹 District filter
     filtered = filtered.filter((item) => {
  if (SelectedDistrict && SelectedDistrict.length > 0) {
    const itemDistrict = item?.Districts || "";

    const isDistrictMatched = SelectedDistrict.some(
      (district) =>
        itemDistrict === district ||
        itemDistrict.startsWith(`${district}-`)
    );

    if (!isDistrictMatched) {
      return false;
    }
  }

      if (
        SelectedTalukasofDistrict &&
        item.Talukas !== SelectedTalukasofDistrict
      )
        return false;

      if (selectedYear && item.Proposal_year !== selectedYear) return false;

      return true;
    });
    if (typeofData === "District") {
      filtered = filtered.filter(
        (item) =>
          item.HeadCode ===
          "3054-2419(Roads and bridge repair maintenance program)",
      );
    } else if (typeofData === "State") {
      filtered = filtered.filter(
        (item) => item.HeadCode === "2515-1238(MLA Representative)",
      );
    }
    // 🔹 Search filter
    if (searchTerm.trim()) {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "")
            .toLowerCase()
            .includes(lower),
        ),
      );
    }

    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [
    budgetEstimation,
    SelectedDistrict,
    SelectedTalukasofDistrict,
    selectedYear,
    searchTerm,
    selectedStatus,
    typeofData, // 👈 IMPORTANT ADD THIS
  ]);

  const proposalEstimate = async () => {
    try {
      const response = await GetAllProposalList();

      console.log("API Response:", response);

      if (response?.data && response.data.length > 0) {
        // Sort latest by date descending (if Date exists)
        const sortedList = [...response.data].sort(
          (a, b) =>
            new Date(b.LatestCreatedDate) - new Date(a.LatestCreatedDate),
        );

        setProposalList(sortedList);
        setCurrentPage(1);
      } else {
        setProposalList([]);
      }
    } catch (err) {
      console.error(err);
      setProposalList([]);
    }
  };

  const getmenu = async () => {
    try {
      const data = await Usermenu();
      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return;
      }
      const roleID = data?.Data?.RoleID;
      setRoleID(roleID);
      // setSelectedStatus("created");
      console.log("sffdsf", data?.Data);
    } catch (error) {
      console.error("Error in AdminNavbar getmenu:", error);
    }
  };
  useEffect(() => {
    proposalEstimate();
    getmenu();
    // setSelectedStatus("created");
  }, []);

  useEffect(() => {
    if (location.state?.filters) {
      const f = location.state.filters;
      setSelectedDistrict(f.SelectedDistrict || []);
      setSelectedTalukasofDistrict(f.SelectedTalukasofDistrict || "");
      setSelectedYear(f.selectedYear || "");
      setSearchTerm(f.searchTerm || "");
      setSelectedStatus(f.selectedStatus || "");
      settypeofData(f.typeofData || "");
      setCurrentPage(f.currentPage || 1);
      navigate(location.pathname, { replace: true });
    } else {
      setSelectedDistrict([]);
      setSelectedTalukasofDistrict("");
      setSelectedYear("");
      setSearchTerm("");
      setSelectedStatus("created");
      settypeofData("");
      setCurrentPage(1);
    }
  }, []);

  // const exportTableByClassToExcel = (
  //   displayedGRS,
  //   selectedStatus,
  //   filename = "GR_santion_Report.xlsx",
  // ) => {
  //   if (!Array.isArray(displayedGRS) || displayedGRS.length === 0) {
  //     alert("No data available");
  //     return;
  //   }

  //   let totalWorks = 0;
  //   let totalGRCount = 0;

  //   const excelData = displayedGRS.map((proposal, index) => {
  //     const works = Number(proposal.TotalWorks || 0);
  //     const grCount =
  //       selectedStatus === "created"
  //         ? Number(proposal.TotalGRCreated || 0)
  //         : Number(proposal.PendingWorks || 0);

  //     totalWorks += works;
  //     totalGRCount += grCount;

  //     return {
  //       "Sr No": index + 1,
  //       "Proposal File No": proposal.Proposal_fileNumber || "-",
  //       "Proposal Year": proposal.Proposal_year || "-",
  //       District: proposal.Districts || "-",
  //       Taluka: proposal.Talukas || "-",
  //       Date: proposal.LatestCreatedDate
  //         ? new Date(proposal.LatestCreatedDate).toLocaleString()
  //         : "-",
  //       "Total No of Work": works,
  //     };
  //   });

  //   /* ---- TOTAL ROW ---- */
  //   excelData.push({
  //     "Sr No": "",
  //     "Proposal File No": "",
  //     "Proposal Year": "",
  //     District: "",
  //     Taluka: "",
  //     Date: "TOTAL",
  //     "Total No of Work": totalWorks,
  //   });

  //   const worksheet = XLSX.utils.json_to_sheet(excelData);

  //   /* ---- COLUMN WIDTH ---- */
  //   worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 22 }));

  //   /* ---- FREEZE HEADER ---- */
  //   worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

  //   /* ---- AUTOFILTER (exclude total row) ---- */
  //   worksheet["!autofilter"] = {
  //     ref: XLSX.utils.encode_range({
  //       s: { r: 0, c: 0 },
  //       e: {
  //         r: excelData.length - 2,
  //         c: Object.keys(excelData[0]).length - 1,
  //       },
  //     }),
  //   };

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Proposal Status Report");

  //   XLSX.writeFile(workbook, filename);
  // };

  // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
  //   try {
  //     setExportingPDF(true);
  //     await new Promise((res) => setTimeout(res, 300));

  //     const table = document.querySelector(`.${tableClass}`);
  //     if (!table) {
  //       setExportingPDF(false);
  //       return;
  //     }

  //     const pdf = new jsPDF("p", "mm", "a4");
  //     const pageWidth = pdf.internal.pageSize.getWidth();
  //     const pageHeight = pdf.internal.pageSize.getHeight();

  //     const topMargin = 25;
  //     const sideMargin = 10;
  //     const bottomMargin = 15;

  //     /* ---- TITLE ---- */
  //     pdf.setFontSize(15);
  //     pdf.setFont("helvetica", "bold");
  //     pdf.text(title, pageWidth / 2, 15, { align: "center" });

  //     /* ---- CAPTURE TABLE ---- */
  //     const canvas = await html2canvas(table, {
  //       scale: 2, // 🔥 Higher quality
  //       useCORS: true,
  //       background: "#0d6efd", // ✅ Clean white background
  //     });

  //     const imgWidth = pageWidth - sideMargin * 2;
  //     const pxToMm = imgWidth / canvas.width;

  //     const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
  //     const usablePageHeightPx = usablePageHeightMm / pxToMm;

  //     let renderedHeight = 0;
  //     let pageNumber = 1;

  //     while (renderedHeight < canvas.height) {
  //       const sliceHeight = Math.min(
  //         usablePageHeightPx,
  //         canvas.height - renderedHeight,
  //       );

  //       const pageCanvas = document.createElement("canvas");
  //       const context = pageCanvas.getContext("2d");

  //       pageCanvas.width = canvas.width;
  //       pageCanvas.height = sliceHeight;

  //       context.drawImage(
  //         canvas,
  //         0,
  //         renderedHeight,
  //         canvas.width,
  //         sliceHeight,
  //         0,
  //         0,
  //         canvas.width,
  //         sliceHeight,
  //       );

  //       const imgData = pageCanvas.toDataURL("image/jpeg", 1.0);

  //       if (pageNumber > 1) pdf.addPage();

  //       pdf.addImage(
  //         imgData,
  //         "JPEG",
  //         sideMargin,
  //         topMargin,
  //         imgWidth,
  //         sliceHeight * pxToMm,
  //       );

  //       /* ---- PAGE NUMBER ---- */
  //       pdf.setFontSize(10);
  //       pdf.setFont("helvetica", "normal");
  //       pdf.text(`Page ${pageNumber}`, pageWidth - 20, pageHeight - 5);

  //       renderedHeight += sliceHeight;
  //       pageNumber++;
  //     }

  //     pdf.save(filename);
  //   } catch (error) {
  //     console.error("PDF Export Error:", error);
  //   } finally {
  //     setExportingPDF(false);
  //   }
  // };
  const exportTableByClassToExcel = async (
    displayedGRS,
    selectedStatus,
    filename = "GR_santion_Report.xlsx",
  ) => {
    if (!Array.isArray(displayedGRS) || displayedGRS.length === 0) {
      alert("No data available");
      return;
    }
    setloading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      let totalWorks = 0;

      const excelData = displayedGRS.map((proposal, index) => {
        const works = Number(proposal.TotalWorks || 0);
        totalWorks += works;

        return {
          "Sr No": index + 1,
          "Proposal File No": proposal.Proposal_fileNumber || "-",
          "Proposal Year": proposal.Proposal_year || "-",
          ...(RoleID == 29 && { "Head Code": proposal.HeadCode || "-" }),
          District: proposal.Districts || "-",
          Taluka: proposal.Talukas || "-",
          Date: proposal.LatestCreatedDate
            ? new Date(proposal.LatestCreatedDate).toLocaleString()
            : "-",
          "Total No of Work": works,
          TotalGRCreated: proposal.TotalGRCreated,
          PendingWorks: proposal.PendingWorks,
        };
      });

      excelData.push({
        Date: "TOTAL",
        "Total No of Work": totalWorks,
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Proposal Status Report",
      );

      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Excel Export Error:", error);
    } finally {
      setloading(false); // ✅ ALWAYS stop loader
    }
  };

  const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
    const table = document.querySelector(`.${tableClass}`);
    if (!table) {
      alert("Table not found");
      return;
    }

    setloading(true);
    setExportingPDF(true);

    // 🔥 Allow React to render loader first
    await new Promise((resolve) => setTimeout(resolve, 900));

    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const topMargin = 25;
      const sideMargin = 10;
      const bottomMargin = 15;

      /* ---- TITLE ---- */
      pdf.setFontSize(15);
      pdf.setFont("helvetica", "bold");
      pdf.text(title, pageWidth / 2, 15, { align: "center" });

      /* ---- CAPTURE TABLE ---- */
      const canvas = await html2canvas(table, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#2C78DB", // safer than background
      });

      const imgWidth = pageWidth - sideMargin * 2;
      const pxToMm = imgWidth / canvas.width;

      const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
      const usablePageHeightPx = usablePageHeightMm / pxToMm;

      let renderedHeight = 0;
      let pageNumber = 1;

      while (renderedHeight < canvas.height) {
        const sliceHeight = Math.min(
          usablePageHeightPx,
          canvas.height - renderedHeight,
        );

        const pageCanvas = document.createElement("canvas");
        const context = pageCanvas.getContext("2d");

        pageCanvas.width = canvas.width;
        pageCanvas.height = sliceHeight;

        context.drawImage(
          canvas,
          0,
          renderedHeight,
          canvas.width,
          sliceHeight,
          0,
          0,
          canvas.width,
          sliceHeight,
        );

        const imgData = pageCanvas.toDataURL("image/jpeg", 1.0);

        if (pageNumber > 1) pdf.addPage();

        pdf.addImage(
          imgData,
          "JPEG",
          sideMargin,
          topMargin,
          imgWidth,
          sliceHeight * pxToMm,
        );

        /* ---- PAGE NUMBER ---- */
        pdf.setFontSize(10);
        pdf.setFont("helvetica", "normal");
        pdf.text(`Page ${pageNumber}`, pageWidth - 20, pageHeight - 5);

        renderedHeight += sliceHeight;
        pageNumber++;
      }

      pdf.save(filename);
    } catch (error) {
      console.error("PDF Export Error:", error);
    } finally {
      setExportingPDF(false);
      setloading(false);
    }
  };

    // /////Added for unique taluka list
  const uniqueTalukas = [
    ...new Set(
      (TalukasofDistrict || [])
        .map((val) => String(val?.ULBNameMarathi || "").trim())
        .filter(Boolean)
    ),
  ].sort((a, b) => a.localeCompare(b, "mr"));
  return (
    <div
      className="col-12 pb-5"
      style={{
        backgroundColor: "#EFF3F8",
        height: "90vh",
        overflowX: "hidden",
        overflowY: "scroll",
        position: "relative",
      }}
    >
      {/* 🔥 Blur Wrapper */}
      <div
        style={{
          filter: loading ? "blur(4px)" : "none",
          pointerEvents: loading ? "none" : "auto",
          transition: "0.2s ease",
        }}
      >
        <div className="col-11 m-auto">
          <div
            className="col-12 px-4 mb-4 mt-3"
            style={{
              filter: loading ? "blur(4px)" : "none",
              pointerEvents: loading ? "none" : "auto",
              transition: "0.2s ease",
            }}
          >
            {/* ================= ROW 1 : HEADING + DOWNLOAD ================= */}
            <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
              <h5 className="fw-bold d-flex align-items-center m-0">
                <img
                  src="/Work-Order-Outwards-Blue64.png"
                  alt="GRSanctionWork"
                  style={{ width: "24px", height: "24px", marginRight: "6px" }}
                />
                {t("GR Sanction Work")}
              </h5>

              <div className="d-flex gap-2">
                <button
                  className="btn btn-success"
                  onClick={() =>
                    exportTableByClassToExcel(
                      filteredBills,
                      "GR_Santion_Report.xlsx",
                    )
                  }
                >
                  {t("Download Excel")}
                </button>

                <button
                  className="btn btn-danger"
                  onClick={() =>
                    downloadTableOnlyAsPDF(
                      "GRStantionWorkstatusReport",
                      "GRStantionWorkstatusReport.pdf",
                      "GRStantionWork Status Report",
                    )
                  }
                >
                  {t("Download PDF")}
                </button>
              </div>
            </div>

            {/* ================= ROW 2 : FILTERS + SEARCH ================= */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexWrap: "nowrap",
              }}
            >
              {/* Type Of Data */}
              {UserRole === "State" && RoleID == 29 && (
                <select
                  value={typeofData}
                  onChange={(e) => settypeofData(e.target.value)}
                  style={filterStyle}
                >
                  <option value="" disabled selected>
                    {t("Select Head Code")}
                  </option>

                  <option value="District">
                    {t("3054-2419(Roads and bridge repair maintenance program)")}
                  </option>

                  <option value="State">
                    {t("2515-1238(MLA Representative)")}
                  </option>
                </select>
              )}

              {/* District Multi Select */}
              {UserRole === "State" && (
                <div style={filterWrapperStyle}>

                  {/* Trigger */}
                  <div
                    onClick={() => setOpenDistrict(true)}
                    style={filterStyle}
                  >
                    {SelectedDistrict.length > 0
                      ? SelectedDistrict.join(", ")
                      : t("Select District")}
                  </div>

                  {/* Dropdown */}
                  {openDistrict && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        width: "100%",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                        zIndex: 9999,
                      }}
                    >
                      {/* All District */}
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "6px 8px",
                          borderBottom: "1px solid #eee",
                          cursor: "pointer",
                          fontSize: "13px",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={isAllSelected}
                          onChange={toggleAllDistricts}
                          style={{ marginRight: "6px" }}
                        />
                        {t("All Districts")}
                      </label>

                      {/* District List */}
                      <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                        {allDistricts.map((district, index) => (
                          <label
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "6px 8px",
                              cursor: "pointer",
                              fontSize: "13px",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={SelectedDistrict.includes(district)}
                              onChange={() => toggleDistrict(district)}
                              style={{ marginRight: "6px" }}
                            />
                            {district}
                          </label>
                        ))}
                      </div>

                      {/* OK Button */}
                      <div
                        style={{
                          borderTop: "1px solid #eee",
                          padding: "6px",
                          textAlign: "right",
                        }}
                      >
                        <button
                          onClick={() => setOpenDistrict(false)}
                          style={{
                            padding: "4px 10px",
                            fontSize: "12px",
                            borderRadius: "6px",
                            border: "none",
                            background: "#0d6efd",
                            color: "#fff",
                            cursor: "pointer",
                          }}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Taluka */}
              <div style={filterWrapperStyle}>
                <select
                  value={SelectedTalukasofDistrict}
                  onChange={(e) => setSelectedTalukasofDistrict(e.target.value)}
                  style={filterStyle}
                >
                  {/* <option value="">
                    {t("Select Taluka")}
                  </option>

                  {TalukasofDistrict?.map((val, index) => (
                    <option key={index} value={val.ULBNameMarathi}>
                      {val.ULBNameMarathi}
                    </option>
                  ))} */}
                  <option value="">{t("Select Taluka")}</option>
                  {uniqueTalukas.map((taluka) => (
                    <option key={taluka} value={taluka}>
                      {taluka}
                    </option>
                  ))}
                </select>
              </div>

              {/* Year */}
              <div style={filterWrapperStyle}>
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  style={filterStyle}
                >
                  <option value="">
                    {t("Select Year")}
                  </option>

                  <option value="2024-2025">2024-2025</option>
                  <option value="2025-2026">2025-2026</option>
                  <option value="2026-2027">2026-2027</option>
                </select>
              </div>

              {/* Status */}
              <div style={filterWrapperStyle}>
                <select
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  style={filterStyle}
                >
                  {/* <option value="" disabled>{t("Select Status")}</option> */}
                  <option value="created">{t("Created")}</option>
                  <option value="pending">{t("Pending")}</option>
                </select>
              </div>

              {/* Search */}
              <div style={filterWrapperStyle}>
                <img
                  src="/Search32.png"
                  alt="Search"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    width: "16px",
                    opacity: 0.6,
                    zIndex: 1,
                  }}
                />

                <input
                  type="text"
                  placeholder={t("Search Here")}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    ...filterStyle,
                    padding: "8px 12px 8px 32px",
                    backgroundColor: "#f1f6fc",
                  }}
                />
              </div>
            </div>
          </div>

          {/* TABLE CARD */}

          <div className="col-12 pb-5">
            <div
              className="m-auto mb-3"
              style={{
                backgroundColor: "white",
                padding: "40px 40px",
                boxShadow: "0px 0px 5px 1px #E4E8EC",
                borderRadius: "20px",
              }}
            >
              <div
                className="col-12 tableDesign"
                style={{ background: "#2C78DB", overflowX: "scroll",  overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative" }}
              >
                <table
                  className="m-0 p-0 GRStantionWorkstatusReport"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10}}>
                    {/* Your existing table header */}
                    <tr
                      style={{
                        color: "white",
                        border: "none",
                        height: "3rem",
                        fontSize: "18px",
                        fontWeight: "400",
                      }}
                    >
                      <th
                        style={{ minWidth: "50px", padding: "2px" }}
                        rowSpan={2}
                      >
                        {t("Sr No")}
                      </th>
                      <th
                        style={{ minWidth: "150px", padding: "8px" }}
                        rowSpan={2}
                      >
                        {t("Proposal File No")}
                      </th>

                      <th
                        style={{ minWidth: "150px", padding: "8px" }}
                        rowSpan={2}
                      >
                        {t("Proposal Year")}
                      </th>
                      {RoleID == 29 ? (
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Head Code")}
                        </th>
                      ) : (
                        ""
                      )}
                      <th
                        style={{ minWidth: "150px", padding: "8px" }}
                        rowSpan={2}
                      >
                        {t("District")}
                      </th>
                      <th
                        style={{ minWidth: "150px", padding: "8px" }}
                        rowSpan={2}
                      >
                        {t("Taluka")}
                      </th>
                      <th
                        style={{ minWidth: "150px", padding: "8px" }}
                        rowSpan={2}
                      >
                        {t("Date")}
                      </th>
                      <th
                        style={{ minWidth: "100px", padding: "4px" }}
                        rowSpan={2}
                      >
                        {t("Total No of Work")}
                      </th>
                      {selectedStatus == "created" ? (
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("GR Created work")}
                        </th>
                      ) : (
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("GR Pending work")}
                        </th>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    <>
                      {displayedGRS.length === 0 ? (
                        <tr>
                          <td
                            colSpan={8}
                            style={{ textAlign: "center", padding: "10px" }}
                          >
                            {t("No data available")}
                          </td>
                        </tr>
                      ) : (
                        displayedGRS.map((proposal, index) => (
                          <tr
                            key={index}
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
                              fontSize: "18px",
                              fontWeight: "400",
                            }}
                          >
                            {/* Sr No */}
                            <td style={{ padding: "8px 8px" }}>
                              {indexOfFirst + index + 1}
                            </td>

                            {/* File Number */}
                            <td style={{ padding: "8px 8px" }}>
                              {proposal.Proposal_fileNumber}
                            </td>

                            <td style={{ padding: "8px 8px" }}>
                              {proposal.Proposal_year}
                            </td>
                            {RoleID == 29 ? (
                              <td style={{ padding: "8px 8px" }}>
                                {proposal.HeadCode}
                              </td>
                            ) : (
                              ""
                            )}
                            {/* District */}
                            <td style={{ padding: "8px 8px" }}>
                              {proposal.Districts}
                            </td>

                            {/* Taluka */}
                            <td style={{ padding: "8px 8px" }}>
                              {proposal.Talukas}
                            </td>

                            {/* Created Date */}
                            <td style={{ padding: "8px 8px" }}>
                              {new Date(
                                proposal.LatestCreatedDate,
                              ).toLocaleString("en-IN")}
                            </td>

                            {/* Total Proposals Count */}
                            <td
                              style={{
                                padding: "8px 8px",
                                textAlign: "center",
                              }}
                            >
                              {proposal.TotalWorks}
                            </td>

                            <td>
                              <button
                                onClick={() => {
                                  let status = "";

                                  if (selectedStatus === "created") {
                                    status = "GR Created";
                                  } else {
                                    status = "Pending";
                                  }
                                  nav(
                                    `/AdminDashboard/SantionWorkList/${encodeURIComponent(proposal.Proposal_fileNumber)}?page=${currentPage}&status=${status}`,
                                    {
                                      state: { filters },
                                    },
                                  );
                                }}
                                //   nav(
                                //     `/AdminDashboard/SantionWorkList/${proposal.Proposal_fileNumber}?page=${currentPage}&status=${status}`,
                                //   );
                                // }}
                                className="m-auto text-center"
                                style={{
                                  width: "5rem",
                                  fontWeight: "650",
                                  padding: "6px 1px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "0.1rem",
                                  background:
                                    "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                  color: "white",
                                  borderRadius: "8px",
                                  margin: "2px",
                                }}
                              >
                                {selectedStatus === "created"
                                  ? proposal.TotalGRCreated || 0
                                  : proposal.PendingWorks || 0}{" "}
                                {t("View")}
                              </button>
                            </td>
                          </tr>
                        ))
                      )}

                      {/* Footer Total Row */}
                    </>
                  </tbody>
                </table>
              </div>

              {/* PAGINATION */}
              <div className="col-12 mt-4 mb-2">
                <div className="row">
                  <div className="col-6">
                    <p className="text-gray-600" style={{ fontSize: "18px" }}>
                      {t("Showing")} {indexOfFirst + 1} {t("to")}{" "}
                      {Math.min(indexOfLast, filteredBills.length)} {t("of")}{" "}
                      {filteredBills.length} {t("entries")}
                    </p>
                  </div>
                  <div
                    className="col-6"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                    }}
                  >
                    <GooglePagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔥 Loader Overlay */}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255,255,255,0.4)",
            backdropFilter: "blur(2px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="Adminloader"></div>
        </div>
      )}
    </div>
  );
  //   return (
  //     <div
  //       className="col-12 pb-5"
  //       style={{
  //         backgroundColor: "#EFF3F8",
  //         height: "90vh",
  //         overflowX: "hidden",
  //         overflowY: "scroll",
  //       }}
  //     >
  //       <div className="col-11 m-auto">
  //         <div className="col-12 px-4 mb-4 mt-3">
  //           {/* ================= ROW 1 : HEADING + DOWNLOAD ================= */}
  //           <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
  //             <h5 className="fw-bold d-flex align-items-center m-0">
  //               <img
  //                 src="/Work-Order-Outwards-Blue64.png"
  //                 alt="GRSanctionWork"
  //                 style={{ width: "24px", height: "24px", marginRight: "6px" }}
  //               />
  //               {t("GR Sanction Work")}
  //             </h5>

  //             <div className="d-flex gap-2">
  //               <button
  //                 className="btn btn-success"
  //                 onClick={() =>
  //                   exportTableByClassToExcel(
  //                     proposallist,
  //                     "GR_Santion_Report.xlsx",
  //                   )
  //                 }
  //               >
  //                 {t("Download Excel")}
  //               </button>

  //               <button
  //                 className="btn btn-danger"
  //                 onClick={() =>
  //                   downloadTableOnlyAsPDF(
  //                     "GRStantionWorkstatusReport",
  //                     "GRStantionWorkstatusReport.pdf",
  //                     "GRStantionWork Status Report",
  //                   )
  //                 }
  //               >
  //                 {t("Download PDF")}
  //               </button>
  //             </div>
  //           </div>

  //           {/* ================= ROW 2 : FILTERS + SEARCH ================= */}
  //           <div
  //             style={{
  //               display: "flex",
  //               alignItems: "center",
  //               gap: "8px",
  //               flexWrap: "nowrap",
  //             }}
  //           >
  //             {/* Type Of Data */}
  //             {UserRole === "State" && RoleID == 29 && (
  //               <select
  //                 value={typeofData}
  //                 onChange={(e) => settypeofData(e.target.value)}
  //                 style={{
  //                   width: "150px",
  //                   padding: "8px",
  //                   border: "1px solid #ccc",
  //                   borderRadius: "8px",
  //                   fontSize: "13px",
  //                   whiteSpace: "nowrap",
  //                   overflow: "hidden",
  //                   textOverflow: "ellipsis",
  //                 }}
  //               >
  //                 <option value="" disabled selected>
  //                  Select HeadCode
  //                 </option>
  //                 <option value="District">
  //                   3054-2419(Roads and bridge repair maintenance program)
  //                 </option>
  //                 <option value="State">2515-1238(MLA Representative)</option>
  //               </select>
  //             )}

  //             {/* District Multi Select */}
  //             {UserRole === "State" && (
  //               <div style={{ position: "relative", width: "160px" }}>
  //                 {/* Trigger */}
  //                 <div
  //                   onClick={() => setOpenDistrict(true)}
  //                   style={{
  //                     width: "100%",
  //                     padding: "8px",
  //                     border: "1px solid #ccc",
  //                     borderRadius: "8px",
  //                     backgroundColor: "#fff",
  //                     cursor: "pointer",
  //                     fontSize: "13px",
  //                     whiteSpace: "nowrap",
  //                     overflow: "hidden",
  //                     textOverflow: "ellipsis",
  //                   }}
  //                 >
  //                   {SelectedDistrict.length > 0
  //                     ? SelectedDistrict.join(", ")
  //                     : t("Select District")}
  //                 </div>

  //                 {/* Dropdown */}
  //                 {openDistrict && (
  //                   <div
  //                     style={{
  //                       position: "absolute",
  //                       top: "100%",
  //                       left: 0,
  //                       width: "100%",
  //                       background: "#fff",
  //                       border: "1px solid #ccc",
  //                       borderRadius: "8px",
  //                       boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
  //                       zIndex: 10,
  //                     }}
  //                   >
  //                     {/* All District */}
  //                     <label
  //                       style={{
  //                         display: "flex",
  //                         alignItems: "center",
  //                         padding: "6px 8px",
  //                         borderBottom: "1px solid #eee",
  //                         cursor: "pointer",
  //                         fontSize: "13px",
  //                       }}
  //                     >
  //                       <input
  //                         type="checkbox"
  //                         checked={isAllSelected}
  //                         onChange={toggleAllDistricts}
  //                         style={{ marginRight: "6px" }}
  //                       />
  //                       {t("All District")}
  //                     </label>

  //                     {/* District List */}
  //                     <div style={{ maxHeight: "150px", overflowY: "auto" }}>
  //                       {[
  //                         ...new Set(AllDistrict?.map((d) => d.District_Marathi)),
  //                       ].map((district, index) => (
  //                         <label
  //                           key={index}
  //                           style={{
  //                             display: "flex",
  //                             alignItems: "center",
  //                             padding: "6px 8px",
  //                             cursor: "pointer",
  //                             fontSize: "13px",
  //                           }}
  //                         >
  //                           <input
  //                             type="checkbox"
  //                             checked={SelectedDistrict.includes(district)}
  //                             onChange={() => toggleDistrict(district)}
  //                             style={{ marginRight: "6px" }}
  //                           />
  //                           {district}
  //                         </label>
  //                       ))}
  //                     </div>

  //                     {/* OK Button */}
  //                     <div
  //                       style={{
  //                         borderTop: "1px solid #eee",
  //                         padding: "6px",
  //                         textAlign: "right",
  //                       }}
  //                     >
  //                       <button
  //                         onClick={() => setOpenDistrict(false)}
  //                         style={{
  //                           padding: "4px 10px",
  //                           fontSize: "12px",
  //                           borderRadius: "6px",
  //                           border: "none",
  //                           background: "#0d6efd",
  //                           color: "#fff",
  //                           cursor: "pointer",
  //                         }}
  //                       >
  //                         OK
  //                       </button>
  //                     </div>
  //                   </div>
  //                 )}
  //               </div>
  //             )}

  //             {/* Taluka */}
  //             <div style={{ width: "160px" }}>
  //               <select
  //                 value={SelectedTalukasofDistrict}
  //                 onChange={(e) => setSelectedTalukasofDistrict(e.target.value)}
  //                 style={{
  //                   width: "100%",
  //                   padding: "8px",
  //                   border: "1px solid #ccc",
  //                   borderRadius: "8px",
  //                   backgroundColor: "#fff",
  //                   fontSize: "13px",
  //                   whiteSpace: "nowrap",
  //                   overflow: "hidden",
  //                   textOverflow: "ellipsis",
  //                 }}
  //               >
  //                 <option value="">{t("Select Taluka")}</option>
  //                 {TalukasofDistrict?.map((val, index) => (
  //                   <option key={index} value={val.ULBNameMarathi}>
  //                     {val.ULBNameMarathi}
  //                   </option>
  //                 ))}
  //               </select>
  //             </div>

  //             {/* Year */}
  //             <div style={{ width: "160px" }}>
  //               <select
  //                 value={selectedYear}
  //                 onChange={(e) => setSelectedYear(e.target.value)}
  //                 style={{
  //                   width: "100%",
  //                   padding: "8px",
  //                   border: "1px solid #ccc",
  //                   borderRadius: "8px",
  //                   backgroundColor: "#fff",
  //                   fontSize: "13px",
  //                   whiteSpace: "nowrap",
  //                   overflow: "hidden",
  //                   textOverflow: "ellipsis",
  //                 }}
  //               >
  //                 <option value="">{t("Select Year")}</option>
  //                 <option value="2024-2025">2024-2025</option>
  //                 <option value="2025-2026">2025-2026</option>
  //                 <option value="2026-2027">2026-2027</option>
  //               </select>
  //             </div>
  //             <div style={{ width: "160px" }}>
  //               <select
  //                 value={selectedStatus}
  //                 onChange={(e) => setSelectedStatus(e.target.value)}
  //                 style={{
  //                   width: "100%",
  //                   padding: "8px",
  //                   border: "1px solid #ccc",
  //                   borderRadius: "8px",
  //                   backgroundColor: "#fff",
  //                   fontSize: "13px",
  //                   whiteSpace: "nowrap",
  //                   overflow: "hidden",
  //                   textOverflow: "ellipsis",
  //                 }}
  //               >
  //                 {/* <option value="" disabled>{t("Select Status")}</option> */}
  //                 <option value="created">{t("Created")}</option>
  //                 <option value="pending">{t("Pending")}</option>
  //               </select>
  //             </div>

  //             {/* Search */}
  //             <div style={{ position: "relative", width: "220px" }}>
  //               <img
  //                 src="/Search32.png"
  //                 alt="Search"
  //                 style={{
  //                   position: "absolute",
  //                   top: "50%",
  //                   left: "10px",
  //                   transform: "translateY(-50%)",
  //                   width: "16px",
  //                   opacity: 0.6,
  //                 }}
  //               />
  //               <input
  //                 type="text"
  //                 placeholder={t("Search Here")}
  //                 value={searchTerm}
  //                 onChange={(e) => setSearchTerm(e.target.value)}
  //                 style={{
  //                   width: "100%",
  //                   padding: "8px 12px 8px 32px",
  //                   border: "1px solid #ccc",
  //                   borderRadius: "8px",
  //                   backgroundColor: "#f1f6fc",
  //                   fontSize: "13px",
  //                 }}
  //               />
  //             </div>
  //           </div>
  //         </div>

  //         {/* TABLE CARD */}

  //         <div className="col-12 pb-5">
  //           <div
  //             className="m-auto mb-3"
  //             style={{
  //               backgroundColor: "white",
  //               padding: "40px 40px",
  //               boxShadow: "0px 0px 5px 1px #E4E8EC",
  //               borderRadius: "20px",
  //             }}
  //           >
  //             <div
  //               className="col-12 tableDesign"
  //               style={{ background: "#2C78DB", overflowX: "scroll" }}
  //             >
  //               <table
  //                 className="m-0 p-0 GRStantionWorkstatusReport"
  //                 style={{ width: "100%", borderCollapse: "collapse" }}
  //               >
  //                 <thead>
  //                   {/* Your existing table header */}
  //                   <tr
  //                     style={{
  //                       color: "white",
  //                       border: "none",
  //                       height: "3rem",
  //                       fontSize: "12px",
  //                       fontWeight: "400",
  //                     }}
  //                   >
  //                     <th
  //                       style={{ minWidth: "50px", padding: "2px" }}
  //                       rowSpan={2}
  //                     >
  //                       {t("Sr No")}
  //                     </th>
  //                     <th
  //                       style={{ minWidth: "150px", padding: "8px" }}
  //                       rowSpan={2}
  //                     >
  //                       {t("Proposal File No")}
  //                     </th>

  //                     <th
  //                       style={{ minWidth: "150px", padding: "8px" }}
  //                       rowSpan={2}
  //                     >
  //                       {t("Proposal Year")}
  //                     </th>
  //                        {RoleID == 29 ? (
  //                       <th
  //                         style={{ minWidth: "150px", padding: "8px" }}
  //                         rowSpan={2}
  //                       >
  //                         {t("Head Code")}
  //                       </th>
  //                     ) : (
  //                       ""
  //                     )}
  //                     <th
  //                       style={{ minWidth: "150px", padding: "8px" }}
  //                       rowSpan={2}
  //                     >
  //                       {t("District")}
  //                     </th>
  //                     <th
  //                       style={{ minWidth: "150px", padding: "8px" }}
  //                       rowSpan={2}
  //                     >
  //                       {t("Taluka")}
  //                     </th>
  //                     <th
  //                       style={{ minWidth: "150px", padding: "8px" }}
  //                       rowSpan={2}
  //                     >
  //                       {t("Date")}
  //                     </th>
  //                     <th
  //                       style={{ minWidth: "100px", padding: "4px" }}
  //                       rowSpan={2}
  //                     >
  //                       {t("Total No of Work")}
  //                     </th>
  //                     {selectedStatus == "created" ? (
  //                       <th
  //                         style={{ minWidth: "150px", padding: "8px" }}
  //                         rowSpan={2}
  //                       >
  //                         {t("GR Created work")}
  //                       </th>
  //                     ) : (
  //                       <th
  //                         style={{ minWidth: "150px", padding: "8px" }}
  //                         rowSpan={2}
  //                       >
  //                         {t("GR Pending work")}
  //                       </th>
  //                     )}
  //                   </tr>
  //                 </thead>

  //                 <tbody>
  //                   <>
  //                     {displayedGRS.length === 0 ? (
  //                       <tr>
  //                         <td
  //                           colSpan={8}
  //                           style={{ textAlign: "center", padding: "10px" }}
  //                         >
  //                           {t("No data available")}
  //                         </td>
  //                       </tr>
  //                     ) : (
  //                       displayedGRS.map((proposal, index) => (
  //                         <tr
  //                           key={index}
  //                           style={{
  //                             backgroundColor:
  //                               index % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
  //                             fontSize: "12px",
  //                             fontWeight: "400",
  //                           }}
  //                         >
  //                           {/* Sr No */}
  //                           <td style={{ padding: "8px 8px" }}>
  //                             {indexOfFirst + index + 1}
  //                           </td>

  //                           {/* File Number */}
  //                           <td style={{ padding: "8px 8px" }}>
  //                             {proposal.Proposal_fileNumber}
  //                           </td>

  //                           <td style={{ padding: "8px 8px" }}>
  //                             {proposal.Proposal_year}
  //                           </td>
  //                             {RoleID==29? <td style={{ padding: "8px 8px" }}>
  //                             {proposal.HeadCode}
  //                           </td>:""}
  //                           {/* District */}
  //                           <td style={{ padding: "8px 8px" }}>
  //                             {proposal.Districts}
  //                           </td>

  //                           {/* Taluka */}
  //                           <td style={{ padding: "8px 8px" }}>
  //                             {proposal.Talukas}
  //                           </td>

  //                           {/* Created Date */}
  //                           <td style={{ padding: "8px 8px" }}>
  //                             {new Date(
  //                               proposal.LatestCreatedDate,
  //                             ).toLocaleString()}
  //                           </td>

  //                           {/* Total Proposals Count */}
  //                           <td
  //                             style={{ padding: "8px 8px", textAlign: "center" }}
  //                           >
  //                             {proposal.TotalWorks}
  //                           </td>

  //                           <td>
  //                             <button
  //                               onClick={() => {
  //                                 let status = "";

  //                                 if (selectedStatus === "created") {
  //                                   status = "GR Created";
  //                                 } else {
  //                                   status = "Pending";
  //                                 }

  //                                 nav(
  //                                   `/AdminDashboard/SantionWorkList/${proposal.Proposal_fileNumber}?page=${currentPage}&status=${status}`,
  //                                 );
  //                               }}
  //                               className="m-auto text-center"
  //                               style={{
  //                                 width: "5rem",
  //                                 fontWeight: "650",
  //                                 padding: "6px 1px",
  //                                 display: "flex",
  //                                 justifyContent: "center",
  //                                 alignItems: "center",
  //                                 gap: "0.1rem",
  //                                 background:
  //                                   "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
  //                                 color: "white",
  //                                 borderRadius: "8px",
  //                                 margin: "2px",
  //                               }}
  //                             >
  //                               {selectedStatus === "created"
  //                                 ? proposal.TotalGRCreated || 0
  //                                 : proposal.PendingWorks || 0}{" "}
  //                               {t("View")}
  //                             </button>
  //                           </td>

  //                           {/* View Button */}
  //                           {/* <td>
  //             <button
  //               className="btn btn-success btn-sm px-3 my-auto"
  //               style={{
  //                 cursor: "pointer",
  //                 color: "white",
  //                 border: "none",
  //                 // padding: "6px 8px",
  //                 borderRadius: "14px",
  //                 fontSize: "10px",
  //                 display: "inline-flex",
  //                 justifyContent: "center",
  //                 alignItems: "center",
  //                 gap: "2px",
  //                 whiteSpace: "nowrap",
  //               }}
  //             >
  //               <img
  //                 src="/view32.png"
  //                 alt="View Icon"
  //                 style={{ width: "14px", height: "14px" }}
  //               />

  // <Link
  //   to={`/AdminDashboard/GRSanctionWork/SantionWorkList/${proposal.ProposalID}/`}
  //   style={{  textDecoration: "none" }}
  //   className="btn btn-success"
  // >
  //   View
  // </Link>
  //             </button>

  //           </td> */}
  //                         </tr>
  //                       ))
  //                     )}

  //                     {/* Footer Total Row */}
  //                   </>
  //                 </tbody>
  //               </table>
  //             </div>

  //             {/* PAGINATION */}
  //             <div className="col-12 mt-4 mb-2">
  //               <div className="row">
  //                 <div className="col-6">
  //                   <p className="text-gray-600" style={{ fontSize: "14px" }}>
  //                     {t("Showing")} {indexOfFirst + 1} {t("to")}{" "}
  //                     {Math.min(indexOfLast, filteredBills.length)} {t("of")}{" "}
  //                     {filteredBills.length} {t("entries")}
  //                   </p>
  //                 </div>
  //                 <div
  //                   className="col-6"
  //                   style={{
  //                     display: "flex",
  //                     alignItems: "center",
  //                     justifyContent: "end",
  //                   }}
  //                 >
  //                   <button
  //                     onClick={() => setCurrentPage(1)}
  //                     disabled={currentPage === 1}
  //                     style={{
  //                       backgroundColor: "white",
  //                       color: "black",
  //                       border: "1px solid lightgrey",
  //                       cursor: "pointer",
  //                       fontSize: "20px",
  //                       width: "2rem",
  //                     }}
  //                   >
  //                     &laquo;
  //                   </button>
  //                   <button
  //                     onClick={() => setCurrentPage(currentPage - 1)}
  //                     disabled={currentPage === 1}
  //                     style={{
  //                       backgroundColor: "white",
  //                       color: "black",
  //                       border: "1px solid lightgrey",
  //                       cursor: "pointer",
  //                       fontSize: "20px",
  //                       borderLeft: "none",
  //                       width: "2rem",
  //                     }}
  //                   >
  //                     &lt;
  //                   </button>
  //                   <button
  //                     style={{
  //                       background:
  //                         "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
  //                       color: "white",
  //                       cursor: "pointer",
  //                       fontSize: "20px",
  //                       width: "2.4rem",
  //                       border: "1px solid lightgrey",
  //                       borderLeft: "none",
  //                     }}
  //                   >
  //                     {currentPage}
  //                   </button>
  //                   <button
  //                     onClick={() => setCurrentPage(currentPage + 1)}
  //                     disabled={currentPage === totalPages || totalPages === 0}
  //                     style={{
  //                       backgroundColor: "white",
  //                       color: "black",
  //                       border: "1px solid lightgrey",
  //                       cursor: "pointer",
  //                       fontSize: "20px",
  //                       borderLeft: "none",
  //                       width: "2rem",
  //                     }}
  //                   >
  //                     &gt;
  //                   </button>
  //                   <button
  //                     onClick={() => setCurrentPage(totalPages)}
  //                     disabled={currentPage === totalPages || totalPages === 0}
  //                     style={{
  //                       backgroundColor: "white",
  //                       color: "black",
  //                       border: "1px solid lightgrey",
  //                       cursor: "pointer",
  //                       fontSize: "20px",
  //                       borderLeft: "none",
  //                       width: "2rem",
  //                     }}
  //                   >
  //                     &raquo;
  //                   </button>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>

  //   );
}

export default GRSanctionWorks;
